var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"header":_vm.header,"pageIcon":"directions","content":_vm.content,"sitecode":_vm.school.site_code}}),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('Roadmap')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }